import { createReducer, createActions } from "reduxsauce";
import Immutable from "seamless-immutable";

const { Types, Creators } = createActions({
  getLeaveRequest: ["leave_id"],
  getLeaveSuccess: ["dataLeave"],
  getLeaveFailure: null,
});

export const GetLeaveTypes = Types;
export default Creators;

export const INITIAL_STATE = Immutable({
  leave_id: null,
  fetching: null,
  success: null,
  dataLeave: null,
  error: null,
});

export const GetLeaveSelectors = {
  getData: (state: any) => state.getLeave.data,
  isFetching: (state: any) => state.getLeave.fetching,
  isSuccess: (state: any) => state.getLeave.success,
  hasError: (state: any) => state.getLeave.error,
};

export const request = (state: any, { leave_id }: any) => {
  const updateData = {
    fetching: true,
    success: false,
    error: false,
    leave_id,
  };
  const newState = state.merge ? state.merge(updateData) : { ...state, ...updateData };
  return newState;
};

export const success = (state: any, action: any) => {
  const { dataLeave } = action;
  const updateData = {
    fetching: false,
    success: true,
    error: false,
    dataLeave: dataLeave?.data,
  };
  const newState = state.merge ? state.merge(updateData) : { ...state, ...updateData };
  return newState;
};

export const failure = (state: any) => {
  const updateData = {
    fetching: false,
    success: false,
    error: true,
    dataLeave: null,
  };
  const newState = state.merge ? state.merge(updateData) : { ...state, ...updateData };
  return newState;
};

export const reducer = createReducer(INITIAL_STATE, {
  [Types.GET_LEAVE_REQUEST]: request,
  [Types.GET_LEAVE_SUCCESS]: success,
  [Types.GET_LEAVE_FAILURE]: failure,
});
